module.exports = __webpack_public_path__ + "img/discovery.ee134350.svg";